import { EditFilled, WarningFilled } from '@ant-design/icons'
import { Button, Progress, Row, Switch } from 'antd'
import moment from 'moment'
import TimeActionHeroPanelSummaryGraph from '../TimeActionHeroPanelSummaryGraph/TimeActionHeroPanelSummaryGraph'
import './TimeActionHeroPanel.style.less'
import { useHorizontalScroll } from './TimeActionHeroPanel.helper'
import { lowerCase } from 'lodash'
import PBFPermission from '@/screens/Order/components/PBFPermission'
import { COLLABORATOR_ROLE_OWNER } from '@/screens/Order/Pages/Order.constant'

export function OtdProgressGraph(props: { date; percentage }) {
  const { date, percentage } = props

  const calculateDays = () => {
    const currentDate = moment(new Date())
    const deliveryDate = moment(date)
    return moment.duration(deliveryDate.diff(currentDate)).asDays()
  }

  return (
    <li className="chart-component odt">
      <Progress
        type="circle"
        width={110}
        strokeWidth={12}
        strokeColor="#4A8DC0"
        gapPosition="right"
        strokeLinecap="square"
        percent={percentage}
        format={() => (
          <div>
            {date && (
              <div className="word-wrap odt" style={{ fontWeight: 600 }}>
                <div>{moment(date).format('D')}</div>
                <div>{moment(date).format('MMM')}</div>
              </div>
            )}
          </div>
        )}
      />
      <h6 className="section-name-chart odt">
        Delivery {calculateDays() > 0 ? 'in' : 'late'}{' '}
        {calculateDays().toFixed(0).toString().replace('-', '')} Days
      </h6>
    </li>
  )
}

interface Props {
  onShowAllComment: () => void
  onShowAllDialog: () => void
  data: any
  onSwitch: (value: boolean) => void
  activeSection: string
  onSectionChange: (id: string) => void
  onEditWorkFlow: () => void
  collaborator: any
  isCheck: boolean
}

function TimeActionHeroPanel(props: Props) {
  const scrollRef = useHorizontalScroll()
  const deliveryDateGraph = props.data.sections.find(
    (item) => lowerCase(item?.name) == 'delivery'
  )

  return (
    <div className="time-action-hero-panel-container">
      <Row justify={'space-between'}>
        <div className="ian-name summary-switch text-right">
          <Switch
            checkedChildren="Timeline"
            unCheckedChildren="Tasks"
            size="default"
            checked={props.isCheck}
            onChange={props.onSwitch}
          />
        </div>
      </Row>
      <Row wrap={false}>
        <div className="workflow-text-container">
          <Row wrap={false} align={'middle'} style={{ margin: '18px 0' }}>
            <p className="workflow-text">Workflow</p>
            <PBFPermission roles={[COLLABORATOR_ROLE_OWNER]}>
              <Button style={{ border: 'none' }} onClick={props.onEditWorkFlow}>
                <EditFilled className="edit-icon" />
              </Button>
            </PBFPermission>
          </Row>
          <Row wrap={false}>
            <p className="tasks-text">
              {props.data?.task_progress?.done_tasks}/
              {props.data?.task_progress?.all_tasks}{' '}
              <span className="task-unit">tasks</span>{' '}
              <span className="task-percentage">
                ({props.data?.task_progress?.progress.toFixed()}% done)
              </span>
            </p>
          </Row>
          {props.data?.urgent_tasks?.urgent_tasks !== 0 && (
            <div className="urgent-task-container">
              <WarningFilled
                style={{
                  color: props.data?.urgent_tasks.is_alert
                    ? '#c03261'
                    : '#EF9747',
                }}
              />
              <p
                style={{
                  color: props.data?.urgent_tasks.is_alert
                    ? '#c03261'
                    : '#EF9747',
                }}
              >
                {props.data?.urgent_tasks?.urgent_tasks} urgent tasks
              </p>
            </div>
          )}
          <Row wrap={false} style={{ marginTop: 10 }}>
            <Button className="button-action" onClick={props.onShowAllComment}>
              All Comments
            </Button>
            <Button className="button-action" onClick={props.onShowAllDialog}>
              All Documents
            </Button>
          </Row>
        </div>
        <div className="graph-progress-container">
          <ul
            style={{ paddingLeft: '0' }}
            className="time-action-hero-graph-container"
            ref={scrollRef}
          >
            <TimeActionHeroPanelSummaryGraph
              data={props.data.sections}
              activeTabId={props.activeSection}
              onTabChange={props.onSectionChange}
            />
          </ul>
          <OtdProgressGraph
            date={deliveryDateGraph?.orders?.to_be_delivered_date}
            percentage={deliveryDateGraph?.progress}
          />
        </div>
      </Row>
    </div>
  )
}

export default TimeActionHeroPanel
